/**
 * Asynchronously loads the component for DocumentPage
 */

import * as React from 'react';
import { lazyLoad } from '../../../../../utils/loadable';
import { LoadingIndicator } from '../../../../components/LoadingIndicator';

export const ReportPage = lazyLoad(
  () => import('./ReportPrefiller'),
  module => module.Prefiller,
  {
    fallback: <LoadingIndicator />,
  },
);
